var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAccountCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3C9.72 3 3 9.72 3 18C3 26.28 9.72 33 18 33C26.28 33 33 26.28 33 18C33 9.72 26.28 3 18 3ZM10.605 27.42C11.25 26.07 15.18 24.75 18 24.75C20.82 24.75 24.765 26.07 25.395 27.42C23.355 29.04 20.79 30 18 30C15.21 30 12.645 29.04 10.605 27.42ZM18 21.75C20.19 21.75 25.395 22.635 27.54 25.245C29.07 23.235 30 20.73 30 18C30 11.385 24.615 6 18 6C11.385 6 6 11.385 6 18C6 20.73 6.93 23.235 8.46 25.245C10.605 22.635 15.81 21.75 18 21.75ZM18 9C15.09 9 12.75 11.34 12.75 14.25C12.75 17.16 15.09 19.5 18 19.5C20.91 19.5 23.25 17.16 23.25 14.25C23.25 11.34 20.91 9 18 9ZM15.75 14.25C15.75 15.495 16.755 16.5 18 16.5C19.245 16.5 20.25 15.495 20.25 14.25C20.25 13.005 19.245 12 18 12C16.755 12 15.75 13.005 15.75 14.25Z",
    fill: "#106EC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountCircle);
export default __webpack_public_path__ + "static/media/ic_account_circle.63efc9619d6cbb489ec6d5d3c4f1b088.svg";
export { ForwardRef as ReactComponent };